import { SELECT_STUDENT } from './selected-student-actions';

const defaultState = null;

/**
 * Selected student Reducer
 *
 * Consumes SELECT_STUDENT action
 *
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - the selected student
 */
export default function (state = defaultState, action) {
    if (!action) return state;

    switch (action.type) {
    case SELECT_STUDENT:
        return action.payload;

    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./containers/class-details/selected-student-reducer.js